import {Component, computed, effect, inject, resource, signal, Signal} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {TranslatePipe} from "@ngx-translate/core";
import{v4 as uuid} from "uuid";
import {HttpClient} from "@angular/common/http";
import {DatePipe} from "@angular/common";

import { MatDialog } from '@angular/material/dialog';
import {MessageViewComponent} from "../../../shared/modals/message-view/message-view.component";
import {RouterLink} from "@angular/router";
import {LoaderElementComponent} from "../../../shared/loader-element/loader-element.component";

@Component({
  selector: 'app-offers',
  imports: [
    FormsModule,
    TranslatePipe,
    DatePipe,
    RouterLink,
    LoaderElementComponent
  ],
  templateUrl: './offer-listing.component.html',
  styleUrl: './offer-listing.component.scss'
})
export class OfferListingComponent {
  private http: HttpClient = inject(HttpClient);
  private matDialog = inject(MatDialog);

  private offersState = signal(uuid());

  protected offersResource = resource({
    request: this.offersState,
    loader: () => new Promise((resolve) => this.http.get("/api/quotation").subscribe(resolve))
  })

  protected offers: Signal<any[]> = computed(() => (this.offersResource.hasValue() && this.offersResource.value()) || []) as Signal<any[]>;

  //user filter input
  protected searchStr: Signal<string> = signal("");


  protected filteredOffers: Signal<any> = computed(() => this.offers()?.filter((offer: any) =>
      this.searchStr() === '' ||
      offer.name.includes(this.searchStr()) ||
      offer.email.includes(this.searchStr()) ||
      offer.date.toString().includes(this.searchStr())
  ));

  onMessageOpen(offer: any) {
    this.matDialog.open( MessageViewComponent, {
      data: { message: offer.description },
      minWidth: '40vw'
    });
  }


}
